import React from "react"

import { Grid } from "@mui/material"

import {
	MatesCheckbox,
	MatesMultiSelect,
	MatesSelect,
	MatesTextField,
} from "@sinossi/mates-react-library"

import { UseFormReturn } from "react-hook-form"
import {
	t,
	Trans,
} from "@lingui/macro"
import { i18n } from "@lingui/core"

import { MatesButtonRadio } from "commons/mates-button-radio"
import { ContractType } from "models/contract"
import {
	AssetType,
} from "models/asset"

interface BrandRequisiteFormProps extends UseFormReturn
{
	formEntry: string
}
interface BrandRequisiteFormState
{
	storeEnabled: boolean
	landEnabled: boolean
	sectionActive: boolean
}
export class BrandRequisiteForm extends React.Component<BrandRequisiteFormProps, BrandRequisiteFormState>
{
	constructor(props: BrandRequisiteFormProps)
	{
		super(props)

		let storeEnabled = this.props.getValues(this.props.formEntry + ".enableStore")
		let landEnabled = this.props.getValues(this.props.formEntry + ".enableLand")
		const sectionActive = this.props.getValues(this.props.formEntry + ".active") === "y"

		if (!storeEnabled && !landEnabled){
			storeEnabled = true
			landEnabled= true
			this.props.setValue(this.props.formEntry + ".enableStore", true)
			this.props.setValue(this.props.formEntry + ".enableLand", true)
		}

		this.state = {
			storeEnabled: storeEnabled,
			landEnabled: landEnabled,
			sectionActive: sectionActive,
		}

		this.syncAssetTypeWithSliders()
	}

	private contractTypeEntries = () => {
		const typeEntries: Record<string, string> = {}

		for(const typeKey in ContractType) {
			typeEntries[typeKey] = /*i18n*/ i18n._("enums.contract-type." + typeKey)
		}
		return typeEntries
	}

	private syncAssetTypeWithSliders = () => {
		const fieldName = `${this.props.formEntry}.assetType`
		const { storeEnabled, landEnabled } = this.state
		if (storeEnabled && !landEnabled) {
			this.props.setValue(fieldName, AssetType.WAREHOUSE_OR_STORE)
		} else if (!storeEnabled && landEnabled) {
			this.props.setValue(fieldName, AssetType.PLOT_OF_LAND)
		} else if (!storeEnabled && !landEnabled) {
			this.props.setValue(fieldName, null)
		} else {
			const currentValue = this.props.getValues(fieldName)
			if (!currentValue) {
				this.props.setValue(fieldName, AssetType.WAREHOUSE_OR_STORE)
			}
		}
	}

	private setSlidersStore = (value: boolean): boolean => {
		this.setState((prevState) => {
			let storeEnabled = prevState.storeEnabled
			let landEnabled = prevState.landEnabled

			if (!prevState.storeEnabled) {
				storeEnabled = true
				landEnabled = true
			} else if (!prevState.landEnabled) {
				storeEnabled = false
				landEnabled = true
			} else {
				storeEnabled = false
			}

			return {
				storeEnabled,
				landEnabled,
			}
		}, () => {
			this.props.setValue(this.props.formEntry + ".enableStore", this.state.storeEnabled)
			this.props.setValue(this.props.formEntry + ".enableLand", this.state.landEnabled)
			this.syncAssetTypeWithSliders()
		})
		return value
	}

	private setSlidersLand = (value: boolean): boolean => {
		this.setState((prevState) => {
			let storeEnabled = prevState.storeEnabled
			let landEnabled = prevState.landEnabled

			if (!prevState.landEnabled) {
				storeEnabled = true
				landEnabled = true
			} else if (!prevState.storeEnabled) {
				storeEnabled = true
				landEnabled = false
			} else {
				landEnabled = false
			}

			return {
				storeEnabled,
				landEnabled,
			}
		}, () => {
			this.props.setValue(this.props.formEntry + ".enableStore", this.state.storeEnabled)
			this.props.setValue(this.props.formEntry + ".enableLand", this.state.landEnabled)
			this.syncAssetTypeWithSliders()
		})

		return value
	}

	private changeActiveState = (data: string): string => {
		this.setState(() => ({ sectionActive: !this.state.sectionActive }))
		return data
	}

	render()
	{
		const assetTypeOptions = Object.values(AssetType).map((type: any) => (
			<option key={type} value={type}>
				<Trans id = {`enums.asset-types.${type}`}>
				</Trans>
			</option>
		))

		return (
			<Grid container rowSpacing={3} columnSpacing={2} alignItems="center">
				{this.props.formEntry !== "requisitesGeneric" &&
				<Grid item xs={12}>
					<MatesButtonRadio
						label={"Attiva"}
						name={`${this.props.formEntry}.active`}
						control={this.props.control}
						trigger={this.props.trigger}
						formState={this.props.formState}
						radios={[{label:"Si", value:"y"}, {label:"No", value:"n"}]}
						onChange={this.changeActiveState}
					/>
				</Grid>
				}

				<Grid item xs={12} md={8}>
					<MatesMultiSelect
						name={`${this.props.formEntry}.contracts`}
						label={t({
							id: "brandProfile.contract",
							message: "Tipologia contratto",
						})}
						variant="outlined"
						disabled={!this.state.sectionActive}
						control={this.props.control}
						formState={this.props.formState}
						trigger={this.props.trigger}
						entries={this.contractTypeEntries()}
					/>
				</Grid>
				<Grid item xs={12} md={4}>
					<MatesButtonRadio
						label={t({
							id: "brandProfile.window",
							message: "Vetrine",
						})}
						name={`${this.props.formEntry}.window`}
						disabled={!this.state.sectionActive}
						control={this.props.control}
						trigger={this.props.trigger}
						formState={this.props.formState}
						radios={[{label:"Si", value:"y"}, {label:"No", value:"n"}]}
					/>
				</Grid>

				<Grid item xs={6} md={2}>
					<MatesCheckbox
						name={`${this.props.formEntry}.enableStore`}
						label={t({
							id: "brandProfile.immobile-slider",
							message: "Immobile (mq)",
						})}
						control={this.props.control}
						formState={this.props.formState}
						trigger={this.props.trigger}
						disabled={!this.state.sectionActive}
						onChange={this.setSlidersStore}
					/>
				</Grid>
				<Grid item xs={6} md={3}>
					<MatesTextField
						name={`${this.props.formEntry}.minGla`}
						label="GLA (min)"
						disabled={!this.state.storeEnabled || !this.state.sectionActive}
						control={this.props.control}
						trigger={this.props.trigger}
						formState={this.props.formState}
					/>
				</Grid>
				<Grid item xs={6} md={3}>
					<MatesTextField
						name={`${this.props.formEntry}.maxGla`}
						label="GLA (max)"
						disabled={!this.state.storeEnabled || !this.state.sectionActive}
						control={this.props.control}
						trigger={this.props.trigger}
						formState={this.props.formState}
					/>
				</Grid>
				<Grid item xs={12} md={4}>
					<MatesButtonRadio
						label={t({
							id: "brandProfile.single-floor",
							message: "Singolo piano",
						})}
						name={`${this.props.formEntry}.singleFloor`}
						disabled={!this.state.sectionActive}
						control={this.props.control}
						trigger={this.props.trigger}
						formState={this.props.formState}
						radios={[{label:"Si", value:"y"}, {label:"No", value:"n"}]}
					/>
				</Grid>

				<Grid item xs={6} md={2}>
					<MatesCheckbox
						name={`${this.props.formEntry}.enableLand`}
						label={t({
							id: "brandProfile.land-slider",
							message: "Terreno (mq)",
						})}
						control={this.props.control}
						formState={this.props.formState}
						trigger={this.props.trigger}
						disabled={!this.state.sectionActive}
						onChange={this.setSlidersLand}
					/>
				</Grid>
				<Grid item xs={6} md={3}>
					<MatesTextField
						name={`${this.props.formEntry}.minLandArea`}
						label="Area (min)"
						disabled={!this.state.landEnabled || !this.state.sectionActive}
						control={this.props.control}
						trigger={this.props.trigger}
						formState={this.props.formState}
					/>
				</Grid>
				<Grid item xs={6} md={3}>
					<MatesTextField
						name={`${this.props.formEntry}.maxLandArea`}
						label="Area (max)"
						disabled={!this.state.landEnabled || !this.state.sectionActive}
						control={this.props.control}
						trigger={this.props.trigger}
						formState={this.props.formState}
					/>
				</Grid>

				<Grid item xs={12} md={4}>
					<MatesSelect
						variant={"outlined"}
						label={t({
							id: "brandProfile.preferredAssetType",
							message: "Tipo di proprietà preferita",
						})}
						name={`${this.props.formEntry}.assetType`}
						control={this.props.control}
						trigger={this.props.trigger}
						formState={this.props.formState}
						disabled={!this.state.storeEnabled || !this.state.landEnabled  || !this.state.sectionActive}
					>
						{assetTypeOptions}
					</MatesSelect>
				</Grid>
			</Grid>
		)
	}
}
